import React, { useState } from 'react';
import {
    UserPlus,
    Search,
    Edit2,
    UserX,
    Users,
    UserCheck,
    UserMinus,
    Shield,
    Filter,
    ChevronDown
} from 'lucide-react';
import AddUserModal from '../components/AddUserModal';
import './UsersRoles.css';

const UsersRoles = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [activeRoleTab, setActiveRoleTab] = useState('All Roles');
    const [activeStatusTab, setActiveStatusTab] = useState('All Status');
    const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
    const [showMoreFilters, setShowMoreFilters] = useState(false);

    // Modernized KPI data with icons and status colors
    const stats = [
        {
            label: 'TOTAL USERS',
            value: '10',
            icon: <Users size={20} />,
            color: '#4167BF',
            bg: 'rgba(65, 103, 191, 0.1)'
        },
        {
            label: 'ACTIVE',
            value: '9',
            icon: <UserCheck size={20} />,
            color: '#10B981',
            bg: 'rgba(16, 185, 129, 0.1)'
        },
        {
            label: 'INACTIVE',
            value: '1',
            icon: <UserMinus size={20} />,
            color: '#64748B',
            bg: 'rgba(100, 116, 139, 0.1)'
        },
        {
            label: 'ROLES',
            value: '4',
            icon: <Shield size={20} />,
            color: '#FF5526',
            bg: 'rgba(99, 102, 241, 0.1)'
        },
    ];

    const users = [
        { id: 1, name: 'Jacob Shahjan', email: 'jacob@velocity.com', role: 'Bid Manager', roleColor: '#FFF1EC', roleText: '#E9471D', status: 'active', activeProposals: 8, lastLogin: 'Just now', created: 'Jan 5, 2025', initials: 'JS', avatarColor: '#10B981' },
        { id: 2, name: 'Sarah Chen', email: 'sarah@velocity.com', role: 'Admin', roleColor: '#F5F3FF', roleText: '#FF5526', status: 'active', activeProposals: 0, lastLogin: '12 min ago', created: 'Feb 10, 2025', initials: 'SC', avatarColor: '#FF5526' },
        { id: 3, name: 'Tom Wilson', email: 'tom@velocity.com', role: 'Reviewer', roleColor: '#ECFDF5', roleText: '#059669', status: 'active', activeProposals: 2, lastLogin: '28 min ago', created: 'Apr 15, 2025', initials: 'TW', avatarColor: '#FF5526' },
        { id: 4, name: 'Alex Kim', email: 'alex@velocity.com', role: 'Editor', roleColor: '#FFF1EC', roleText: '#FF5526', status: 'active', activeProposals: 3, lastLogin: '2 hrs ago', created: 'May 20, 2025', initials: 'AK', avatarColor: '#F59E0B' },
        { id: 5, name: 'Riya Patel', email: 'riya@velocity.com', role: 'Bid Manager', roleColor: '#FFF1EC', roleText: '#E9471D', status: 'active', activeProposals: 2, lastLogin: '3 hrs ago', created: 'Jun 8, 2025', initials: 'RP', avatarColor: '#FF5526' },
        { id: 6, name: 'Mike Ross', email: 'mike@velocity.com', role: 'Bid Manager', roleColor: '#FFF1EC', roleText: '#E9471D', status: 'active', activeProposals: 3, lastLogin: '1 hr ago', created: 'Jul 12, 2025', initials: 'MR', avatarColor: '#EF4444' },
        { id: 7, name: 'James Donovan', email: 'james@velocity.com', role: 'Bid Manager', roleColor: '#FFF1EC', roleText: '#E9471D', status: 'active', activeProposals: 4, lastLogin: '30 min ago', created: 'Aug 3, 2025', initials: 'JD', avatarColor: '#10B981' },
        { id: 8, name: 'Priya Sharma', email: 'priya@velocity.com', role: 'Editor', roleColor: '#FFF1EC', roleText: '#FF5526', status: 'active', activeProposals: 2, lastLogin: '4 hrs ago', created: 'Sep 14, 2025', initials: 'PS', avatarColor: '#FF5526' },
        { id: 9, name: 'David Lee', email: 'david@velocity.com', role: 'Reviewer', roleColor: '#F9FAFB', roleText: '#4B5563', status: 'inactive', activeProposals: 0, lastLogin: '2 weeks ago', created: 'Oct 1, 2025', initials: 'DL', avatarColor: '#EF4444' },
    ];

    const roleTabs = ['All Roles', 'Admin', 'Bid Manager', 'Reviewer', 'Editor'];
    const statusTabs = ['All Status', 'Active', 'Inactive'];

    return (
        <div className="users-roles-container">
            <header className="page-header">
                <div className="header-content">
                    <h3>Users & Roles</h3>
                    <p>Manage users, assign roles, and control access permissions</p>
                </div>
                <div className="header-actions">
                    <button className="add-user-btn" onClick={() => setIsAddUserModalOpen(true)}>
                        <UserPlus size={16} />
                        Add User
                    </button>
                </div>
            </header>

            <section className="kpi-grid">
                {stats.map((stat, i) => (
                    <div key={i} className="kpi-card-modern">
                        <div className="kpi-icon-box" style={{ backgroundColor: stat.bg, color: stat.color }}>
                            {stat.icon}
                        </div>
                        <div className="kpi-info">
                            <span className="kpi-label">{stat.label}</span>
                            <span className="kpi-value">{stat.value}</span>
                        </div>
                    </div>
                ))}
            </section>

            <div className="table-controls-modern">
                <div className="controls-left">
                    <div className="search-bar-modern">
                        <Search size={18} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Search users..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

                    <div className="segment-group">
                        {roleTabs.map(tab => (
                            <button
                                key={tab}
                                className={`segment-btn ${activeRoleTab === tab ? 'active' : ''}`}
                                onClick={() => setActiveRoleTab(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="controls-right">
                    <button
                        className={`more-filters-btn ${showMoreFilters ? 'active' : ''}`}
                        onClick={() => setShowMoreFilters(!showMoreFilters)}
                    >
                        <Filter size={16} />
                        More Filters
                        <ChevronDown size={14} className={showMoreFilters ? 'rotate' : ''} />
                    </button>

                    {showMoreFilters && (
                        <div className="dropdown-filters-panel">
                            <div className="filter-group-inner">
                                <span className="filter-group-label">Status:</span>
                                <div className="segment-group">
                                    {statusTabs.map(tab => (
                                        <button
                                            key={tab}
                                            className={`segment-btn ${activeStatusTab === tab ? 'active' : ''}`}
                                            onClick={() => setActiveStatusTab(tab)}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="users-table-wrapper">
                <table className="users-table">
                    <thead>
                        <tr>
                            <th>USER <span className="sort-icon">⇅</span></th>
                            <th>EMAIL <span className="sort-icon">⇅</span></th>
                            <th>ROLE <span className="sort-icon">⇅</span></th>
                            <th>STATUS <span className="sort-icon">⇅</span></th>
                            <th>PROPOSALS</th>
                            <th>LAST ACTIVE <span className="sort-icon">⇅</span></th>
                            <th>CREATED <span className="sort-icon">⇅</span></th>
                            <th>ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(user => (
                            <tr key={user.id}>
                                <td className="user-cell">
                                    <div className="user-avatar" style={{ backgroundColor: user.avatarColor }}>
                                        {user.initials}
                                    </div>
                                    <span className="user-name">{user.name}</span>
                                </td>
                                <td className="email-cell">{user.email}</td>
                                <td className="role-cell">
                                    <span
                                        className="role-badge"
                                        style={{ backgroundColor: user.roleColor, color: user.roleText }}
                                    >
                                        {user.role}
                                    </span>
                                </td>
                                <td className="status-cell">
                                    <span className={`status-pill ${user.status}`}>
                                        {user.status}
                                    </span>
                                </td>
                                <td className="proposals-cell">{user.activeProposals}</td>
                                <td className="login-cell">{user.lastLogin}</td>
                                <td className="created-cell">{user.created}</td>
                                <td className="actions-cell">
                                    <button className="action-btn"><Edit2 size={14} /></button>
                                    <button className="action-btn delete"><UserX size={14} /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <AddUserModal
                isOpen={isAddUserModalOpen}
                onClose={() => setIsAddUserModalOpen(false)}
            />
        </div>
    );
};

export default UsersRoles;
